import React, { useState } from 'react';
// import Button from "../Button";
import ButtonComponent from '../ui/ButtonComponent';
import { useNavigate } from 'react-router-dom';
import { iconsPath, imagePath } from '../../utils/imagePath';

import { Drawer } from '../ui/Drawer';
import Sidebar from './Sidebar';
import CreateProjectModal from '../ProjectCreation/CreateNewProject';

import { set_open_log_out } from '../../redux/Slice/userSlice';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import useClickOutside from '../UseClickOutside';
import { SimpleModal } from '../ui/NormalModal';

const Navbar = React.memo(() => {
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const navigate = useNavigate();

  const userName = useSelector((state) => state.user.user_name);

  const profileDetails = [
    { id: 1, name: userName || 'user', icon: imagePath?.group96Image },
    { id: 2, name: 'Logout', icon: iconsPath?.logoutIcon },
  ];

  const handleLoginLogout = (name) => {
    if (name == 2) {
      // setOpen1(true);
      store.dispatch(set_open_log_out(true));
    } else if (name == 1) {
      // setIsProfileModalOpen(!isProfileModalOpen);
      navigate('/profile');
    }
    setIsProfileModalOpen(false);
  };

  const modalRef = React.useRef(null);
  useClickOutside(modalRef, () => {
    setIsProfileModalOpen(false);
  });

  return (
    <div className="w-[100vw] h-[68px] bg-[#1e1f22] shadow-md shadow-[rgba(0,0,0,0.4)] z-[9990] ">
      <div className="flex justify-between items-center h-full px-[4%]">
        <div className="flex items-center gap-[20px] relative  lg:right-[40px]">
          <img
            // onClick={() => {
            //   window.location.href =
            //     process.env.REACT_APP_SPATIAL_WEB_URL + 'dashboard';
            // }}
            onClick={() => {
              navigate('/dashboard');
            }}
            className="w-[150px] md:w-[190px] step-1 cursor-pointer"
            src={imagePath?.logoImage}
            alt=""
          />
          {/* <h1 className="anybody-500 text-[#ffffff] text-[26px]">SaptialGrid</h1> */}
        </div>
        <div className="flex items-center gap-[20px] -mr-[2%]">
          {/* <div className="step-3 relative w-[200px] lg:w-[323px] hidden md:flex">
            <Input
              leftIcon={
                <img
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#B8B8B8] "
                  src={imagePath?.SearchIcon}
                  alt=""
                />
              }
              className=" w-[200px] lg:w-[323px] !h-[28px] !rounded-[50px] bg-[#444447] border border-[#5c5c5c] pl-10 text-white placeholder:text-[#B8B8B8]"
              type="text"
              placeholder="Search"
            />
          </div> */}

          <ButtonComponent
            onClick={() => setOpen(true)}
            className="step-2 hidden md:flex bg-[#EE2B2A]  !h-[34px]  items-center justify-center text-white px-4 gap-3 rounded-[3px] text-nowrap min-w-[140px]  max-w-[140px] hover:bg-[#EE2B2A] font-bold"
          >
            <img className=" h-3 w-3" src={imagePath?.group96Image} alt="" />{' '}
            <p className="text-[12px] font-bold">New Project</p>
          </ButtonComponent>

          <div
            onClick={() => {
              // handleLoginLogout();
              if(isProfileModalOpen) {
                // setIsProfileModalOpen(false);
              } else {
                setIsProfileModalOpen(true);
              }
            }}
            className=" cursor-pointer bg-[#EE2B2A] w-[23px] h-[23px] text-[12px] text-[#ffffff] rounded-full relative flex  items-center justify-center"
          >
            <span
              // id="ram"
              className="border-2 border-[#EE2B2A] h-[31px] w-[31px]  rounded-full absolute"
            ></span>
            {userName?.charAt(0)?.toUpperCase() || 'S'}
          </div>

          <div
            onClick={() => {
              setIsOpen(true);
            }}
           className="flex lg:hidden  text-[#ffffff] rounded-full relative items-center justify-center"
          >
            <img
              src={iconsPath.menuIcon}
              alt="menu icon"
              className="h-[26px] w-[26px] cursor-pointer"
            />
          </div>
        </div>
      </div>
      {open && (
        <SimpleModal
          className={'!min-w-fit !p-0 !bg-transparent !overflow-hidden flex justify-center items-center'}
          isOpen={open}
          onClose={() => setOpen(false)}
        >
          <CreateProjectModal closeModal={() => setOpen(false)} />
        </SimpleModal>
      )}

      <Drawer title={'Menu'} isOpen={isOpen} setIsOpen={setIsOpen}>
        <Sidebar className={'shadow-none'} close={() => setIsOpen(false)} />
      </Drawer>

      {isProfileModalOpen && (
        <div
          ref={modalRef}
          className="w-56 bg-[#1e1f22] shadow-lg rounded-lg overflow-hidden  absolute right-5 top-[75px]  animate-fadeIn"
        >
          <div className=" p-2 ">
            <h3
              onClick={() => navigate('/profile')}
              className="text-[#ffffff] font-medium text-lg cursor-pointer"
            >
              Profile
            </h3>
          </div>

          <div className="max-h-60 overflow-y-auto">
            {profileDetails.map((item) => (
              <div
                onClick={() => handleLoginLogout(item.id)}
                key={item.id}
                className="flex cursor-pointer items-center px-4 py-2  transition-colors duration-150  last:border-b-0"
              >
                <div className="w-8 h-8 rounded-full  overflow-hidden flex-shrink-0 bg-[#464644] flex items-center justify-center">
                  {item.icon ? (
                    <img src={item.icon} alt={item.name} className="w-4 h-4" />
                  ) : (
                    <img
                      src={imagePath?.group96Image}
                      alt=""
                      className="w-4 h-4"
                    />
                  )}
                </div>
                <div className="ml-3 flex-grow">
                  <p className="text-white font-medium">
                    {item.name.substring(0, 15)}
                  </p>
                  {item.status && (
                    <p className="text-gray-500 text-sm">{item.status}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

export default Navbar;
